module.exports = __webpack_public_path__ + "distribution/img/kong.c7c54b94.png";